import { useDeployWatcher } from '@skupreme/shared/deploy';
import { ToastRegion } from '@skupreme/shared/ui';
import { useLocation } from 'react-router';

/*
 * Pages a new deploy may reload out from under the user: sign-in and public
 * views. OAuth and email-link callbacks (/redirect, /sso, /verify-email, ...)
 * stay out, so a reload can never replay a one-time code.
 */
const RELOAD_SAFE_PATHS = [
  '/',
  '/login',
  '/register',
  '/forgot-password',
  '/request-password',
  '/accept-invite',
  '/public/*',
];

/** Brings an open tab onto a new deploy (EN-3481). Mount once, inside the router. */
export function DeployWatcher() {
  const { pathname } = useLocation();

  useDeployWatcher({
    currentVersion: import.meta.env.VITE_APP_VERSION,
    pathname,
    reloadSafePaths: RELOAD_SAFE_PATHS,
  });

  return <ToastRegion />;
}
